/* eslint-disable */
import React from "react";
import { Commodities } from '../../../controls/Units';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";
export const UnitsControl: React.FC = () => {
    const [items, setItems] = React.useState<any>([]);
    const [param, setParam] = useParameter("@units");
    const [dictItems, dict] = useDictionary(dictionaryService, "slides-units", [6, 9]);
    React.useEffect(() => {
        if (dictItems) {
            const nextItems = dictItems.map<any>(x => ({
                id: x.id,
                name: (x.getValue("name") as any)[9] as string,
                parent: undefined,
            }));
            setItems(nextItems);
        }
    }, [dictItems]);


    const onChange = values => setParam(values.map(Number));
    const res = React.useMemo(() => <Commodities items={items} value={param} onChange={onChange} />, [items, JSON.stringify(param)]);
    if (!items?.length) {
        return <Skeleton variant="rect" width="168px" height="51px" />
    }
    return res;
};
